import React from "react";
import { useTranslation } from "react-i18next";

interface HeaderTypes {
  className?: string;
}

export default function PrivateFooter(props: HeaderTypes) {
  const { className } = props;
  const { t } = useTranslation();

  return (
    <footer className="w-full h-7 justify-end text-gray-white bg-gray-60 flex items-center px-4">
      <div className={"flex gap-x-2"}>
        <span className={"text-xs"}>{t("allRightReserved")}</span>
      </div>
    </footer>
  );
}
